// src/pages/base/components/DaySummaryModal.jsx

import React from 'react';
import { getColorClasses } from '../../themeConfig';
import { getCompletedFacilities, getInjuredSquadMembers } from '../Base.utils';

const DaySummaryModal = ({ 
  show,
  onClose,
  currentCampaign,
  facilities,
  currentResearch,
  squad,
  dayEvents,
  config
}) => {
  if (!show) return null;

  const completedFacilities = getCompletedFacilities(facilities);
  const injuredSquad = getInjuredSquadMembers(squad);

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
      <div className={`bg-gray-900 border-2 ${getColorClasses(config.colors.primary, 'border')} rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto`}>
        <h2 className={`text-2xl font-bold ${getColorClasses(config.colors.primary)} mb-4`}>
          DAY {currentCampaign.day} - REPORT
        </h2>

        {/* Completed facilities */}
        {completedFacilities.length > 0 && (
          <div className="mb-4">
            <h3 className="text-lg font-bold text-green-400 mb-2">✓ FACILITIES COMPLETED</h3>
            {completedFacilities.map(f => (
              <p key={f.id} className="text-gray-300">- {f.name}</p>
            ))}
          </div>
        )}

        {/* Research progress */}
        {currentResearch && (
          <div className="mb-4">
            <h3 className="text-lg font-bold text-blue-400 mb-2">📊 RESEARCH PROGRESS</h3>
            <p className="text-gray-300">
              {currentResearch.name}: {currentResearch.progress}%
            </p>
          </div>
        )}

        {/* Squad healing */}
        {injuredSquad.length > 0 && (
          <div className="mb-4">
            <h3 className="text-lg font-bold text-yellow-400 mb-2">⚕️ SQUAD HEALING</h3>
            {injuredSquad.map(s => (
              <p key={s.id} className="text-gray-300">
                - {s.name}: {s.health}/{s.max_health} HP
              </p>
            ))}
          </div>
        )}

        {/* Day events */}
        {dayEvents.length > 0 && (
          <div className="mb-4">
            <h3 className="text-lg font-bold text-purple-400 mb-2">📰 EVENTS</h3>
            {dayEvents.map((event, idx) => (
              <div key={idx} className="bg-gray-800 p-3 rounded mb-2">
                <p className="font-bold text-white">{event.title}</p>
                <p className="text-sm text-gray-400">{event.description}</p>
                {event.rewards && (
                  <p className="text-sm text-green-400 mt-1">
                    Rewards: {Object.entries(event.rewards).map(([k, v]) => `+${v} ${k}`).join(', ')}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}

        <button
          onClick={onClose}
          className={`w-full py-2 font-bold ${getColorClasses(config.colors.primary, 'bg')} rounded mt-4 hover:opacity-80 transition-opacity`}
        >
          CONTINUE
        </button>
      </div>
    </div>
  );
};

export default DaySummaryModal;